export const START_CANVAS = 'START_CANVAS'
export const LOADED_ANIMATECC_JS = 'LOADED_ANIMATECC_JS'
export const SET_MOUSE_DOWN = 'SET_MOUSE_DOWN'
export const SET_NUM_MOUSE_OVER = 'SET_NUM_MOUSE_OVER'
export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION'




/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/